import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiAIAssistanceService } from './fi-ai-assistance.service';
import { FiAIAssistanceHelperService } from '@fi-shared/fi-ai-assistance/fi-ai-assistance-helper.service';
import { FiAiAssistancePanelHandlerComponent } from '@fi-shared/fi-ai-assistance/fi-ai-assistance-panel-handler/fi-ai-assistance-panel-handler.component';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

@NgModule({
    imports: [CommonModule, FormsModule, MatIconModule, FiAppTextSharedModule, CdkTextareaAutosize],
    declarations: [FiAiAssistancePanelHandlerComponent],
    providers: [FiAIAssistanceService, FiAIAssistanceHelperService],
    exports: [FiAiAssistancePanelHandlerComponent],
})
export class FiAiAssistanceModule {}
